import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M2.66667 9.33333C3.03486 9.33333 3.33333 9.63181 3.33333 10V12C3.33333 12.3682 3.63181 12.6667 4 12.6667H12C12.3682 12.6667 12.6667 12.3682 12.6667 12V10C12.6667 9.63181 12.9651 9.33333 13.3333 9.33333C13.7015 9.33333 14 9.63181 14 10V12C14 13.1046 13.1046 14 12 14H4C2.89543 14 2 13.1046 2 12V10C2 9.63181 2.29848 9.33333 2.66667 9.33333Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M7.99999 10.3333C8.1768 10.3333 8.34637 10.2631 8.4714 10.1381L10.8047 7.80474C11.0651 7.54439 11.0651 7.12228 10.8047 6.86193C10.5444 6.60158 10.1223 6.60158 9.86193 6.86193L8.66666 8.05719V2.66667C8.66666 2.29848 8.36818 2 7.99999 2C7.6318 2 7.33333 2.29848 7.33333 2.66667V8.05719L6.13807 6.86193C5.87772 6.60158 5.45561 6.60158 5.19526 6.86193C4.93491 7.12228 4.93491 7.54439 5.19526 7.80474L7.52859 10.1381C7.65361 10.2631 7.82318 10.3333 7.99999 10.3333Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }